import React from 'react';
import { SvgIconProps } from '@mui/material';

export const TwitterIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M18.9 1.71411H22.5806L14.5406 10.9267L24 23.465H16.5943L10.7897 15.8621L4.15543 23.465H0.471429L9.07029 13.6078L0 1.71583H7.59429L12.8331 8.66383L18.9 1.71411ZM17.6057 21.257H19.6457L6.48 3.80725H4.29257L17.6057 21.257Z"
            fill="currentColor"
        />
    </svg>
);

export default TwitterIcon;
